import React from "react";
import { Button, VStack } from "@chakra-ui/react";
import { Form, TextInput } from "components";
import { StoredDisclaimerProcedure } from "duck";
import { FormValues, getValidationSchema } from "./duck";

interface DisclaimerProcedureForm {
  onSubmit(values: FormValues): Promise<any>;
  onCancel(): void;
  disclaimerProcedure?: StoredDisclaimerProcedure;
}

const DisclaimerProcedureForm: React.FC<DisclaimerProcedureForm> = ({
  onCancel,
  onSubmit,
  disclaimerProcedure
}) => {
  const validation = getValidationSchema(disclaimerProcedure);

  return (
    <Form<FormValues> onSubmit={onSubmit} {...validation}>
      <VStack spacing={6} py={6}>
        <TextInput
          placeholder="Procedure type"
          name="title"
          label="Procedure type"
        />
        <TextInput
          placeholder="Procedure description"
          name="description"
          label="Procedure description"
        />
      </VStack>
      <Form.Controls submitText="Save">
        <Button variant="outline" colorScheme="gray" onClick={onCancel}>
          Cancel
        </Button>
      </Form.Controls>
    </Form>
  );
};

export default DisclaimerProcedureForm;
